import React, { useState } from 'react';
import TweenOne from 'rc-tween-one';
import QueueAnim from 'rc-queue-anim';
import { Tabs, Row, Col, Image, List, Space } from 'antd';
import Patent from '@/assets/about/patent.png';
import Honour2017 from '@/assets/about/2017honour.png';
import Honour2018 from '@/assets/about/2018honour.png';
import { HonourIcon } from './AboutIcon';
import { getChildrenToRender } from '@/utils';
import { useTranslation } from 'react-i18next';

function Feature7(props) {
  const { dataSource, isMobile, ...tagProps } = props;
  const { titleWrapper } = dataSource;

  const [currentTab, setCurrentTab] = useState('1');
  const { t } = useTranslation();
  const childrenItem = dataSource.block.measure.map(($item, i) => {
    const { number, children: child, ...childProps } = $item;
    const numberChild = number.children.replace(/[^0-9.-]/g, '');
    const { unit, ...numberProps } = number;
    return (
      <Col {...childProps} key={i.toString()}>
        <TweenOne
          {...numberProps}
          animation={{
            Children: {
              value: parseFloat(numberChild),
              floatLength:
                parseFloat(numberChild) -
                Math.floor(parseFloat(numberChild)) >
                0
                  ? 2
                  : 0,
              formatMoney: false
            },
            duration: 1000,
            delay: 300,
            ease: 'easeInOutCirc'
          }}
          component="span"
        >
          0
        </TweenOne>
        {unit && <span {...unit}>{unit.children}</span>}
        <p {...child}>{t(child.children)}</p>
      </Col>
    );
  });

  const GetContent = ({ label, imgSrc }) =>
    <>
      <div style={{ backgroundColor: '#fff', width: 250, height: 300, padding: '20px', borderRadius: '20px' }}>
        {!!imgSrc && (
          <Image src={imgSrc} alt={label} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
        )}
      </div>
      <p style={{ width: 338, marginTop: '20px', textAlign: 'center' }}>{label}</p>
    </>;

  const onTabChange = (key) => {
    setCurrentTab(key);
  };

  const items = [
    {
      key: '1',
      label: t('about.corePatentDetail'),
      children: <GetContent label={t('about.corePatentDetail')} imgSrc={Patent} />,
      icon: <HonourIcon />
    },
    {
      key: '2',
      label: t('about.2017Awards'),
      children: <GetContent label={t('about.2017Awards')} imgSrc={Honour2017} />,
      icon: <HonourIcon />
    },
    {
      key: '3',
      label: t('about.2018Awards'),
      children: <GetContent label={t('about.2018Awards')} imgSrc={Honour2018} />,
      icon: <HonourIcon />
    },
    // 2021图片待补充
    {
      key: '4',
      label: t('about.2021Awards'),
      children: <GetContent label={t('about.2021Awards')} imgSrc={''} />,
      icon: <HonourIcon />
    },
    // 2022图片待补充
    {
      key: '5',
      label: t('about.2022Awards'),
      children: <GetContent label={t('about.2022Awards')} imgSrc={''} />,
      icon: <HonourIcon />
    }
  ];

  const getMobileContent = (key) => {
    if (['4', '5'].includes(key)) {
      return <></>;
    }
    return items.find((item) => item.key === key).children;
  };

  return (
    <div {...tagProps} {...dataSource.wrapper}>
      <div {...dataSource.page}>
        <Row>
          <Col span={16}>
            <div {...dataSource.titleWrapper}>
              {titleWrapper.children.map((val, i) => getChildrenToRender(val, i, t))}
            </div>
          </Col>
          <Col span={8}>
            <div>
              <QueueAnim type="bottom" component={Row}>
                {childrenItem}
              </QueueAnim>
            </div>
          </Col>
        </Row>
        <div {...dataSource.OverPack}>
          <div className={isMobile ? 'feature7-mobile' : 'feature7-text'}>
            {
              !isMobile && <Tabs
                defaultActiveKey="1"
                tabBarStyle={{ borderRight: 'unset' }}
                items={items}
                onChange={onTabChange}
                tabPosition="left"
                indicator={{ size: 0 }}
              />
            }
            {
              isMobile && (
                <Space direction="vertical" size="large">
                  <List
                    bordered={false}
                    dataSource={items}
                    renderItem={(item) => (
                      <List.Item onClick={() => onTabChange(item.key)}
                                 className={currentTab === item.key ? 'active' : ''}>
                        {item.icon} {item.label}
                      </List.Item>
                    )}
                  />
                  {getMobileContent(currentTab)}
                </Space>
              )
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Feature7;
